import OutageNotificationBanner from "./OutageNotificationBanner";
import { useNotificationStore,NotificationState } from "./NotificationStore";
import {
  StyledOutageNotificationContainer,
  StyledNoOutageNotificationBanner,
  StyledOutageNotificationContainerSpacer,
} from "./styles";
import { NotificationDetail } from "./NotificationDetail";
import { INotification } from "./NotificationInterface";
import { useSideSheetStore } from "../components/SideSheet/useSideSheetStore";

const OutageNotificationContainer = (): JSX.Element => {
  const { openSideSheet } = useSideSheetStore();

  const outageNotifications = useNotificationStore(
    (state: NotificationState) => state.outageNotifications
  );
  const closeOutageBanner = useNotificationStore(
    (state: NotificationState) => state.closeOutageBanner
  );

  const onLearnMoreClick = (notification: INotification) => {
    openSideSheet({
      body:(<NotificationDetail notification={notification!}  />)
    });
  };

  return (
    <>
    {
    outageNotifications.length > 0 &&
    <StyledOutageNotificationContainerSpacer>
      <StyledOutageNotificationContainer data-testid="outage-notification-container">
        {outageNotifications.length > 0 && <StyledNoOutageNotificationBanner />}
        {outageNotifications && outageNotifications.length > 0 && (
          <OutageNotificationBanner
            onClose={closeOutageBanner}
            onLearnMoreClick={onLearnMoreClick}
            items={outageNotifications}
          />
        )}
      </StyledOutageNotificationContainer>
    </StyledOutageNotificationContainerSpacer>
    }
    </>
  );
};
export default OutageNotificationContainer;
